import { getCookies } from './getCookies';
export const getCookieByName = (name) => {
    const cookies = getCookies();
    if (!cookies) {
        return null;
    }
    const cookieNameMatch = Object.keys(cookies).find((cookieName) => cookieName === name);
    if (!cookieNameMatch) {
        return null;
    }
    return decodeURIComponent(cookies[cookieNameMatch]);
};
